import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Download01 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="download-01">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0012 2C12.5535 2 13.0012 2.44772 13.0012 3V12.6551L16.2547 9.64524C16.6601 9.27019 17.2928 9.2948 17.6679 9.70022C18.0429 10.1056 18.0183 10.7383 17.6129 11.1134L12.6803 15.6765C12.297 16.0311 11.7054 16.0311 11.3221 15.6765L6.38951 11.1134C5.9841 10.7383 5.95948 10.1056 6.33453 9.70022C6.70958 9.2948 7.34226 9.27019 7.74768 9.64524L11.0012 12.6551V3C11.0012 2.44772 11.4489 2 12.0012 2ZM3.28457 19.684C3.67044 19.2889 4.30356 19.2814 4.69868 19.6673C4.91413 19.8777 5.21128 20 5.52595 20H18.4741C18.7887 20 19.0859 19.8777 19.3013 19.6673C19.6964 19.2814 20.3296 19.2889 20.7154 19.684C21.1013 20.0792 21.0938 20.7123 20.6987 21.0982C20.1047 21.6782 19.3041 22 18.4741 22H5.52595C4.69593 22 3.89528 21.6782 3.30132 21.0982C2.9062 20.7123 2.8987 20.0792 3.28457 19.684Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
